<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear keyword="">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.type" id="type" label="項目">
                            <div is="option" value="5-1">C5-1</div>
                            <div is="option" value="5-2">C5-2</div>
                            <div is="option" value="5-3">C5-3</div>
                            <div is="option" value="7-1">C7</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload">
                    <b-button variant="primary" @click="create()"><b-icon-file></b-icon-file>產生核評內容</b-button>
                </btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th>年度</th>
                            <th>核評內容</th>
                            <th>條件</th>
                            <th>點數</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.PaSetID">
                        <td data-th="學年度">{{item.SYear}}</td>
                        <td data-th="核評內容">{{item.Value}}</td>
                        <td data-th="條件">每次</td>
                        <td data-th="點數"><b-button size="sm" variant="link" @click="edit(item.PaSetID)">{{item.Score}}</b-button></td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload"></Detail>
    </page-main>
</template>

<script>
    import Detail from './pasetDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'g1paset',
        api: '/api/g1paset/',
        components: { Detail },
        data: {
            query: { type: '5-2' }
        },
        methods: {
            create: function () {
                if (this.query.syear === "" || this.query.type === "") {
                    this.$bvToast.toast("請選擇學年度以及項目", { title: '發生錯誤', variant: 'danger', solid: true });
                    return;
                }

                this.$http({ method: 'put', url: '/api/g1paset/put', data: this.query })
                    .then((res) => {
                        this.$bvToast.toast('已產生 ' + res.data.syear + ' 學年度 C' + res.data.type + ' 核評內容，請確認點數分配', { title: '', variant: 'success', solid: true });
                        this.query.syear = res.data.syear;
                        this.query.type = res.data.type;
                        this.load();
                    });
            },
        }
    });
</script>

<style>
</style>